<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>

export default {
  created() {
  }
}
</script>

<style >
  html,body,h3 {
    margin: 0;
    padding: 0;
    
  }
  /* #app{
    background-color: aqua;
  } */
</style>
